import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Sparkles, LogOut, ShieldCheck, Shield } from "lucide-react";

const Header = ({ onGoPremium }) => {
  const { user, logout } = useAuth();

  return (
    <header className="flex items-center gap-3 px-4 md:px-6 py-3 border-b border-neutral-200 bg-[#faf8f4]">
      <Link to="/" className="flex items-center gap-2">
        <span className="text-2xl leading-none" aria-hidden>🕌️</span>
        <h1 className="text-[22px] font-extrabold tracking-tight text-neutral-900 lowercase">
          dilli.wiki
        </h1>
      </Link>
      <p className="hidden sm:block text-[15px] text-neutral-500 lowercase">
        a local's guide to falling in love with delhi.
      </p>

      <div className="ml-auto flex items-center gap-2">
        {user ? (
          <>
            {user.is_admin && (
              <Link to="/admin">
                <Button
                  variant="outline"
                  className="h-9 rounded-full border-neutral-300 px-3.5 text-sm font-medium text-neutral-800"
                >
                  <Shield className="mr-1 h-4 w-4" /> Admin
                </Button>
              </Link>
            )}
            {user.is_premium ? (
              <span className="hidden sm:inline-flex items-center gap-1 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700">
                <ShieldCheck className="h-3.5 w-3.5" /> Supporter
              </span>
            ) : (
              <Button
                onClick={onGoPremium}
                className="h-9 rounded-full bg-neutral-900 px-3.5 text-sm font-medium text-white hover:bg-neutral-800"
              >
                <Sparkles className="mr-1 h-4 w-4" /> Go Premium ₹99
              </Button>
            )}
            <span className="hidden md:inline text-sm text-neutral-500 max-w-[160px] truncate">
              {user.email}
            </span>
            <Button
              onClick={logout}
              variant="ghost"
              className="h-9 rounded-full px-3 text-sm text-neutral-600 hover:bg-neutral-100"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </>
        ) : (
          <Link to="/login">
            <Button
              variant="outline"
              className="h-9 rounded-full border-neutral-300 px-4 text-sm font-medium"
            >
              Log in
            </Button>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;
